export default __webpack_public_path__ + "static/media/slide-2.c2ac1803.jpg";